import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getLiveAndVodDetails } from "../../../redux/actions/videoData.actions";
import { conditions } from "../../conditions/conditions";
import { CinemaHamrahState, ConditionName } from "../../../interfaces/enums";
import { livePlayRetryDuration } from "../../environment";
import { shallowEqual } from 'react-redux'
import { checkIsFreeContent, handleCinemaHamrahStates } from "redux-share/actions";
import { setCinemaHamrahState, setGetDetailsFromVoucher } from "redux-share/slices/videoDataSlice";

const useGetDetails = () => {

    const dispatch = useAppDispatch();
    const { params, token, isLiveError } = useAppSelector(({ videoData: { params, token, isLiveError, getDetailsFromVoucher } }) => ({ params, token, isLiveError, getDetailsFromVoucher }), shallowEqual);
    useAppSelector(({ controller: { isEnded } }) => ({ isEnded }), shallowEqual);

    useEffect(() => {

        if (conditions(ConditionName.getDetails)) {
            if (conditions(ConditionName.isCinemaHamrahEnvironment)) {
                (async () => {
                    const isFreeContent = await checkIsFreeContent();
                    if(isFreeContent) dispatch(setCinemaHamrahState(CinemaHamrahState.fullrate)); 
                    else {
                        dispatch(setGetDetailsFromVoucher(true));
                        handleCinemaHamrahStates();
                    }
                    getLiveAndVodDetails();
                })()
            } else getLiveAndVodDetails();
        }
    }, [params.id, params.type]);

    useEffect(() => {
        let interval: any;
        if (conditions(ConditionName.getLiveDetailsInIntervals) && !conditions(ConditionName.isEnded)) interval = setInterval(() => getLiveAndVodDetails(), livePlayRetryDuration);
        else clearInterval(interval);

        return () => clearInterval(interval);
    }, [isLiveError, token])

}

export default useGetDetails;